import { createComponent } from '@ycos/fela'

const SpanContainer = createComponent('div', ({ theme, noPaddingTop, noPaddingTopMobile, addPaddingBottom, addPaddingBottomMobile, isSticky, offsetTop, centerContent, viewportHeight }) => {
  const { spacingMultiplier, rowOffsetTopSmall, rowOffsetTopMedium, rowOffsetTopLarge, rowOffsetTopXLarge, rowOffsetBottomSmall, rowOffsetBottomMedium, rowOffsetBottomLarge, rowOffsetBottomXLarge } = theme
  const topSmall = noPaddingTopMobile ? 0 : rowOffsetTopSmall * spacingMultiplier
  const topMedium = noPaddingTop ? 0 : rowOffsetTopMedium * spacingMultiplier
  const topLarge = noPaddingTop ? 0 : rowOffsetTopLarge * spacingMultiplier
  const topXLarge = noPaddingTop ? 0 : rowOffsetTopXLarge * spacingMultiplier
  const bottomSmall = addPaddingBottomMobile ? rowOffsetBottomSmall * spacingMultiplier : 0;
  const bottomMedium = addPaddingBottom ? rowOffsetBottomMedium * spacingMultiplier : 0;
  const bottomLarge = addPaddingBottom ? rowOffsetBottomLarge * spacingMultiplier : 0;
  const bottomXLarge = addPaddingBottom ? rowOffsetBottomXLarge * spacingMultiplier : 0;
  const displayAttribute = centerContent ? 'flex' : undefined

  return {
    width: '100%',
    paddingTop: `${topSmall}px`,
    paddingBottom: `${bottomSmall}px`,
    height: 'auto',
    position: 'relative',
    display: isSticky ? 'inline-block' : displayAttribute,
    flexDirection: centerContent ? 'column' : undefined,
    justifyContent: centerContent ? 'center' : undefined,

    'screen-medium': {
      position: isSticky ? 'sticky' : 'relative',
      top: isSticky ? `${offsetTop || -topMedium}px` : undefined,
      minHeight: viewportHeight ? '100vh' : undefined,
      paddingTop: `${topMedium}px`,
      paddingBottom: `${bottomMedium}px`
    },

    'screen-large': {
      top: isSticky ? `${offsetTop || -topLarge}px` : undefined,
      paddingTop: `${topLarge}px`,
      paddingBottom: `${bottomLarge}px`
    },

    'screen-xlarge': {
      top: isSticky ? `${offsetTop || -topXLarge}px` : undefined,
      paddingTop: `${topXLarge}px`,
      paddingBottom: `${bottomXLarge}px`
    }
  }
})

export default SpanContainer
